import { useCallback } from 'react';
import { DocumentContent } from '../types';

export const useFileManagement = (
  setAttachments: React.Dispatch<React.SetStateAction<DocumentContent[]>>
) => {
  const scrollToBottom = useCallback(() => {
    // Scroll to bottom of the page with smooth animation
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  }, []);

  const handleFilesAdded = useCallback((newFiles: DocumentContent[]) => {
    setAttachments((prev: DocumentContent[]) => [...prev, ...newFiles]);
    // Scroll to bottom after files are added
    setTimeout(scrollToBottom, 100); // Small delay to ensure state update completes
  }, [setAttachments, scrollToBottom]);

  const handleRemoveAttachment = useCallback((index: number) => {
    setAttachments((prev: DocumentContent[]) => prev.filter((_: DocumentContent, i: number) => i !== index));
  }, [setAttachments]);

  return {
    handleFilesAdded,
    handleRemoveAttachment,
    scrollToBottom, // Export the scroll function
  };
}; 